import React, { createContext, useState, useContext } from 'react'

const CustomDomainContext = createContext()

export const CustomDomainProvider = ({ children }) => {
  const [isPublishToCustomDomain, setIsPublishToCustomDomain] = useState(false)
  const [DNSRecordsDiagnostics, setDNSRecordsDiagnostics] = useState(null)

  return (
    <CustomDomainContext.Provider
      value={{ isPublishToCustomDomain, setIsPublishToCustomDomain, DNSRecordsDiagnostics, setDNSRecordsDiagnostics }}
    >
      {children}
    </CustomDomainContext.Provider>
  )
}

export const useCustomDomain = () => {
  const context = useContext(CustomDomainContext)
  if (context === undefined) {
    return {
      DNSRecordsDiagnostics: null,
      setDNSRecordsDiagnostics: () => {},
      isPublishToCustomDomain: false,
      setIsPublishToCustomDomain: () => {}
    }
  }
  return context
}
